import { Component, inject } from "@angular/core";
import { LogoComponent } from "@shared/components/atoms/logo/logo.component";
import { HeaderButtonComponent } from "@shared/components/molecules/header-button/header-button.component";
import { TranslatePipe } from "@ngx-translate/core";
import { ButtonBadgeComponent } from "@shared/components/atoms/button-badge/button-badge.component";
import { CartStateService } from "@shared/services/cart-state.service";
import { AsyncPipe } from "@angular/common";
import { FavoriteProductsStateService } from "@shared/services/favorite-products-state.service";
import { InfoBannerComponent } from "@shared/components/molecules/info-banner/info-banner.component";

@Component({
  selector: "app-main-header",
  imports: [LogoComponent, HeaderButtonComponent, TranslatePipe, ButtonBadgeComponent, AsyncPipe, InfoBannerComponent],
  templateUrl: "./main-header.component.html",
  styleUrl: "./main-header.component.scss",
})
export class MainHeaderComponent {
  private readonly cartStateService = inject(CartStateService);
  private readonly favoriteProductsStateService = inject(FavoriteProductsStateService);

  readonly cartCount$ = this.cartStateService.productsCount$;
  readonly favoriteProducts = this.favoriteProductsStateService.favoriteProducts;
}
